import React from "react";

import styled from "@mui/material/styles/styled";

import { FeedItem } from "@app/analytics/Home/types";

import Stack, { Row, StackProps } from "@rui/Stack";

const CONTENT_BG_COLOR_BY_TYPE: {
  [key in FeedItem["type"]]?: React.CSSProperties["backgroundColor"];
} = {
  action_item: "#F5F5FE",
  key_question: "#FFF9F2",
  key_question_answer: "#FFF9F2",
  meeting_report: "#F0F5FD",
};

export const Wrapper = styled(Stack)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
}));

export const MainContentContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.25),
}));

export const OuterItemContainer = styled(Stack)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#FFF",
  border: `solid 1px ${theme.palette.shades.neutral[100]}`,
  borderRadius: "4px",
  width: "100%",
  maxWidth: "490px",
  margin: "0px auto", // must have margin-x auto so the feed is centered
  "&:hover": {
    cursor: "pointer",
  },
}));

type ContentProps = StackProps & { type: FeedItem["type"] };

export const Content = styled<React.FC<ContentProps>>(
  ({ type: _t, ...props }) => <Stack {...props} />
)(({ theme, type }) => ({
  flexShrink: 1,
  backgroundColor:
    CONTENT_BG_COLOR_BY_TYPE[type] ?? theme.palette.shades.neutral[50],
  borderRadius: "4px",
  padding: theme.spacing(1),
  color: theme.palette.shades.neutral[700],
}));

const InnerLine = styled(Stack)({
  width: "2px",
  height: "100%",
  borderRadius: "5px",
});

type LineProps = StackProps & { color: React.CSSProperties["color"] };

export const Line = styled<React.FC<LineProps>>(({ color, ...props }) => (
  <Stack variant="center" {...props}>
    <InnerLine sx={{ backgroundColor: color }} />
  </Stack>
))({
  width: "32px",
  minWidth: "32px",
  flex: 1,
});

export const Footer = styled(Row)(({ theme }) => ({
  borderTop: "solid 1px",
  borderColor: theme.palette.shades.neutral[100],
  paddingTop: theme.spacing(1),
}));
